import prefix from 'prefix'
import GetSize from 'get-size'
import CssToMatrix from 'css-to-matrix'

const cssToMatrix = new CssToMatrix()

export function getSize (object) {
  return GetSize(object)
}

export function getPrefix (value = 'transform') {
  return prefix(value)
}

export function getTransform (y = 0, x = 0, rotation = 0, scale = 1) {
  return `translate3d(${x}px,${y}px,0) rotateZ(${rotation}deg) scale3d(${scale},${scale},${scale})`
}

export function getMatrixTransform (x = 0, y = 0, scale = 1, rotation = 0) {
  let mat = cssToMatrix
    .translate3d(x, y, 0)
    .scale3d(scale, scale, scale)
    .rotate(`${rotation}deg`)
    .getMatrixCSS()
  return mat
}

export function getCssMatrix () {
  return cssToMatrix
}



/** WEBPACK FOOTER **
 ** ./src/utils/css.js
 **/